const __WEBPACK_NAMESPACE_OBJECT__ = require("@babylonjs/core/Helpers/sceneHelpers");